import apiFetch from './client';

const API_BASE = process.env.REACT_APP_API_URL || '';

export async function uploadImage(file) {
  const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', 'image');

  const res = await fetch(`${API_BASE}/api/media/`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export function addVideoUrl(url, title) {
  return apiFetch('/api/media/video-url', {
    method: 'POST',
    body: JSON.stringify({ url, title }),
  });
}

// Medienbibliothek: Liste, Verbrauch, Löschen, Verwendungsnachweise
export function getMediaList(mediaType) {
  const q = mediaType ? `?media_type=${encodeURIComponent(mediaType)}` : '';
  return apiFetch(`/api/media/${q}`);
}

export function getMediaUsage() {
  return apiFetch('/api/media/usage');
}

export function getMediaUsageMap() {
  return apiFetch('/api/media/usage-map');
}

export function deleteMedia(mediaId) {
  return apiFetch(`/api/media/${mediaId}`, { method: 'DELETE' });
}

export function getMediaReferences(mediaId) {
  return apiFetch(`/api/media/${mediaId}/references`);
}

// Medium manuell „als verwendet" markieren (extern genutzt, z. B. Logo/Avatar)
export function setMediaKept(mediaId, kept) {
  return apiFetch(`/api/media/${mediaId}/kept`, {
    method: 'POST',
    body: JSON.stringify({ kept }),
  });
}

// Unbenutzte Bilder + verwaiste Dateien aufräumen; dryRun zählt nur
export function cleanupUnusedMedia(dryRun = false) {
  return apiFetch(`/api/media/cleanup-unused${dryRun ? '?dry_run=true' : ''}`, { method: 'POST' });
}

export function generateExerciseImage(name) {
  return apiFetch('/api/ai/generate-exercise-image', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function addMediaToExercise(exerciseId, mediaId, mediaType) {
  const token = sessionStorage.getItem('access_token') || localStorage.getItem('access_token');
  const API_BASE = process.env.REACT_APP_API_URL || '';
  const body = new URLSearchParams();
  body.append('media_id', mediaId);
  body.append('media_type', mediaType);
  body.append('sort_order', '0');

  const res = await fetch(`${API_BASE}/api/exercises/${exerciseId}/media`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export function removeMediaFromExercise(exerciseId, mediaRelId) {
  return apiFetch(`/api/exercises/${exerciseId}/media/${mediaRelId}`, { method: 'DELETE' });
}

export function getMediaFileUrl(mediaId) {
  const API_BASE = process.env.REACT_APP_API_URL || '';
  return `${API_BASE}/api/media/${mediaId}/file`;
}

export async function addMediaToWorkout(workoutId, mediaId, mediaType) {
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  const base = process.env.REACT_APP_API_URL || '';
  const body = new URLSearchParams();
  body.append('media_id', mediaId);
  body.append('media_type', mediaType);
  body.append('sort_order', '0');

  const res = await fetch(`${base}/api/workouts/${workoutId}/media`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export function removeMediaFromWorkout(workoutId, relId) {
  return apiFetch(`/api/workouts/${workoutId}/media/${relId}`, { method: 'DELETE' });
}
